export default () => ({
  enabledFeatures: null,
})
